import { animate } from 'motion';

const animTxts = document.querySelectorAll('.anim-txt');

function wrapWords(node) {
  Array.from(node.childNodes).forEach(child => {
    if (child.nodeType === Node.TEXT_NODE) {
      const text = child.textContent;
      if (!text.trim()) return;

      const parts = text.split(/(\s+)/);
      const fragment = document.createDocumentFragment();

      parts.forEach(part => {
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
        } else if (part) {
          const outer = document.createElement('span');
          outer.className = 'word';
          const inner = document.createElement('span');
          inner.textContent = part;
          outer.appendChild(inner);
          fragment.appendChild(outer);
        }
      });

      child.replaceWith(fragment);
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      wrapWords(child);
    }
  });
}

animTxts.forEach(txt => wrapWords(txt));

const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const txt = entry.target;
      const percent =
        getComputedStyle(txt).getPropertyValue('--percent').trim() || '100%';
      const spans = txt.querySelectorAll('.word > span');

      animate(
        spans,
        {
          opacity: [0, 1],
          transform: [`translateY(${percent})`, 'translateY(0)'],
        },
        {
          duration: 0.5,
          delay: i => i * 0.1,
          easing: 'ease-in-out',
        }
      );

      observer.unobserve(txt);
    });
  },
  { threshold: 0.5 }
);

animTxts.forEach(txt => observer.observe(txt));

//<div class="anim-txt">text<span class="accent">text</span></div>
